import React, {useState} from "react";
import { Box, Typography } from "@mui/material";
import CollapsiblePanel from "../../components/CollapsiblePanel/CollapsiblePanel";
import withdrawIcon from "../../images/withdraw.svg";
import QRCodeDeposit from "../../components/AccountActionsComponents/UserAccountTransfers/QRCodeDeposit";
import CustomerWithdrawal from "../../components/AccountActionsComponents/UserAccountTransfers/CustomerWithdrawal";
import { useSelector } from "react-redux";


function Transfers() {

    const [openPanel, setOpenPanel] = useState(null);

    const togglePanel = (panel) => {
      setOpenPanel((prev) => (prev === panel ? null : panel));
    };

    let configVariables = useSelector((state) => state.config.baseConfig);

    return (
        <Box className="page-container">
            <Box className="header-container">
                <Box className="page-title">
                    Transfers
                </Box>
            </Box>

            <Typography
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "16px",
                    fontFamily: 'Nunito',
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "17.9021px",
                    lineHeight: "30px",
                    color: "#3A3A3A",
                }}
            >
                Select Transfer Type
            </Typography>

            <CollapsiblePanel
                title="Customer Withdrawal"
                icon={withdrawIcon}
                isOpen={openPanel === "voucherWithdrawal"}
                togglePanel={() => togglePanel("voucherWithdrawal")}
            >
                <CustomerWithdrawal />
            </CollapsiblePanel>

            <CollapsiblePanel
                // title="QR Code Deposit"
                title={`${configVariables?.clientKeyword1} Customer ID QR Code`}
                icon={withdrawIcon}
                isOpen={openPanel === "qrCodeDeposit"}
                togglePanel={() => togglePanel("qrCodeDeposit")}
            >
                <QRCodeDeposit />
            </CollapsiblePanel>
        </Box>
    )
}

export default Transfers;